import { PlusOutlined } from '@ant-design/icons';
import type { Brand } from '@shop-monorepo/types';
import type { TableProps } from 'antd';
import { Button } from 'antd';
import { generatePath } from 'react-router-dom';

import { BooleanSelectFilter } from '../../components/BooleanSelectFilter';
import { DeleteButton } from '../../components/DeleteButton';
import { EditButton } from '../../components/EditButton';
import {
  PageContainer,
  PageHeader,
  PageTitle,
  StyledTable,
  TableContainer,
  Toolbar,
} from '../../components/PageLayout';
import { RightAlignedSpace } from '../../components/RightAlignedSpace';
import { StatusIndicator } from '../../components/StatusIndicator';
import { useBrands, useDeleteBrand } from '../../hooks/useBrandQueries';
import { useListNavigate } from '../../hooks/useListReturn';
import { useTableSorter } from '../../hooks/useTableSorter';
import { useBooleanParams } from '../../hooks/useUrlParam';
import { ROUTES } from '../../routes/routes';

export const BrandsPage: React.FC = () => {
  const goToDetail = useListNavigate();
  const { sorter, handleTableChange } = useTableSorter();
  const filters = useBooleanParams(['isActive']);
  const { data: brands, isLoading } = useBrands(sorter, filters);
  const { mutate: deleteBrand } = useDeleteBrand();

  const columns: TableProps<Brand>['columns'] = [
    {
      title: 'Назва',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
    },
    {
      title: 'Статус',
      dataIndex: 'isActive',
      key: 'isActive',
      sorter: true,
      render: (isActive: boolean) => <StatusIndicator isActive={isActive} />,
    },
    {
      title: 'Дія',
      key: 'action',
      align: 'right',
      render: (_, record) => (
        <RightAlignedSpace size="middle">
          <EditButton
            onClick={() => goToDetail(generatePath(ROUTES.BRAND_EDIT, { id: String(record.id) }))}
          />
          <DeleteButton onConfirm={() => deleteBrand(record.id)} entityName={record.name} />
        </RightAlignedSpace>
      ),
    },
  ];

  return (
    <PageContainer>
      <PageHeader>
        <PageTitle>Бренди</PageTitle>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => goToDetail(ROUTES.BRAND_CREATE)}
        >
          Додати бренд
        </Button>
      </PageHeader>
      <Toolbar>
        <BooleanSelectFilter name="isActive" placeholder="Активний" />
      </Toolbar>
      <TableContainer>
        <StyledTable
          columns={columns}
          dataSource={brands || []}
          rowKey="id"
          loading={isLoading}
          pagination={false}
          onChange={handleTableChange}
          scroll={{ x: 400 }}
        />
      </TableContainer>
    </PageContainer>
  );
};
